import React from 'react';
import './studymDoc.css';
import '../DOC/docCard.css';
import moment from 'moment';
import { isMobile } from 'react-device-detect';
import api from '../../api/api';
import { useTranslation } from 'react-i18next';

import date from '../../assets/document/date.png';
import pdf from '../../assets/document/pdf.png';
import mp4 from '../../assets/document/mp4.png';
import png from '../../assets/document/png.png';
import gif from '../../assets/document/gif.png';
import doc from '../../assets/document/doc.png';
import docx from '../../assets/document/docx.png';
import xls from '../../assets/document/xls.png';
import xlsx from '../../assets/document/xlsx.png';
import yout from '../../assets/document/yout.png';
import ass from '../../assets/document/ass.png';
import ebk from '../../assets/document/ebk.png';
import video from '../../assets/document/video.png';
import folder from '../../assets/document/folder.png';
import mp3 from '../../assets/studyMaterial/mp3.png';
import jpg from '../../assets/studyMaterial/jpg.png';
import ppt from '../../assets/studyMaterial/ppt.png';
import pptx from '../../assets/studyMaterial/pptx.png';
import viemo from '../../assets/studyMaterial/viemo.png';
import pbix from '../../assets/studyMaterial/pbix.png';
import videocypher from '../../assets/studyMaterial/videosypher.png';
import zip from '../../assets/studyMaterial/zip.png';
import txt from '../../assets/studyMaterial/txt.png';
import aac from '../../assets/studyMaterial/aac.png';

function getHeadImage(el) {
  let fname = el?.file_name ?? '';
  fname = fname.split('.').pop().toLowerCase();
  const mapping = {
    pdf, docx, pbix, doc, png, ppt, pptx, mp4, mp3,
    xls, xlsx, bmp: xls, gif, jpg, jpeg: jpg, acc: aac,
    txt, zip, tif: xls, rtf: xls, wav: xls,
  };
  return mapping[fname] || 
    (el.category_name === 'Vimeo' ? viemo :
     el.category_name === 'Youtube URL' ? yout :
     el.category_name === 'VDOCipher' ? videocypher : png);
}

function getSubjectImage(type) {
  if (['Assignment', 'Other', 'Images', 'Slides', 'Notes', 'PreviousYearQuestionsPaper'].includes(type)) return ass;
  if (['EBook', 'Exam'].includes(type)) return ebk;
  if (type === 'AudioNotes') return folder;
  if (['Vimeo', 'YoutubeURL', 'VDOCipher'].includes(type)) return video;
  return '';
}

function getFileFormat(el) {
  const ext = el?.file_name?.split('.').pop().toLowerCase();
  if (['wav', 'mp3', 'wma', 'aac'].includes(ext)) return 'audio';
  if (['mp4', 'gif'].includes(ext)) return 'video';
  if (['png', 'jpg', 'jpeg', 'bmp', 'tif'].includes(ext)) return 'image';
  return 'document';
}

function StudymDoc(props) {
  const { t } = useTranslation();
  const {
    el,
    index,
    onMarkComplete,
    isLocked = false,
    isMarked = false,
    posterList = [],
    institute_id,
    student_id,
    user_id,
    student_auth
  } = props;

  const head_image = posterList.length !== 0 ? posterList[0].posterUrl : getHeadImage(el);
  const subject_image = getSubjectImage(props?.type);
  const isVideo = ['YoutubeURL', 'Vimeo', 'VDOCipher'].includes(props.type);
  const newdate = (props?.date ?? '').split(' ')[0];

  const handleCheckboxChange = async () => {
    const request = {
      url: `/api/v1/instFileSystem/update-study-material-read-status`,
      token: student_auth,
      data: {
        inst_id: institute_id,
        user_id,
        student_id,
        file_id: el.file_id,
        read_status: 1,
      },
    };

    try {
      const res = await api.putAuth(request);
      if (res.status === 200) {
        onMarkComplete(index);
      } else {
        alert(t('errors.markCompleteFailedAlert'));
      }
    } catch (err) {
      console.error("API Error:", err);
      alert(t('errors.networkErrorMarkingComplete'));
    }
  };

  return (
    <div className="studymdoc-card">
      {newdate > 15 && <div className="new-files-doc">New Files</div>}

      <div className="student-doc-card-name">
        <div className="studydoc">
          <div className="video-thumbnail-wrapper">
          <button
  className="ssssy-button"
  onClick={() => {
    console.log("🟢 StudymDoc CLICK | index:", index, "| title:", props.heading_name);
    console.log("🔗 Passing element to CardView →:", el);
   !isLocked && props.handleClick(el)}
  }
  disabled={isLocked}
>
              <img src={head_image} className="image-jp" alt="" />
              {isLocked && (
                <div className="locked-overlay">
                  <span className="locked-text">🔒 Locked</span>
                </div>
              )}
            </button>
          </div>

          <div className="sub-headding">
            <span className="head-studym" title={props.heading_name}>{props.heading_name}</span>
            <span className="topic" title={props.topic}>{props.topic}</span>
          </div>

          <div className="text-heading">
            <img src={date} className="image-size" alt="" />
            <span>{props.date == null ? '-' : moment(newdate).format('DD-MM-YYYY')}</span>
          </div>

          <div className="text-heading">
            <img src={subject_image} className="image-size" alt=" " />
            <span title={props.type} className="typeStud">
              {isVideo ? 'Video' : props.type}
            </span>
          </div>

          {!isLocked && (
            <div className="text-heading">
              <label className="custom-checkbox-label">
                <input
                  type="checkbox"
                  checked={isMarked}
                  disabled={isMarked}
                  onChange={handleCheckboxChange}
                />
                <span className="custom-checkbox"></span>
                Completed
              </label>
            </div>
          )}

          {!isLocked && (
            <div className="hoverStud">
              {props.is_readonly === "N" && (
                <button className="download-button1" onClick={() => props.download(el)}>Download</button>
              )}

              {!['YoutubeURL', 'Vimeo', 'VDOCipher', 'AudioNotes', 'Images'].includes(props.type) &&
                !['zip', 'pbix'].includes((props.el?.file_name || '').split('.').pop().toLowerCase()) && (
                  <button className="view-button1" onClick={() => props.handleClick(props.el)}>View</button>
              )}

              {props.type === 'YoutubeURL' && (
                <button
                  className="view-button1"
                  onClick={() => {
                    isMobile
                      ? window.open("https://onlinetest.proctur.com/media.php?v=" + btoa(props.el.youtubeVideoID).replaceAll("=", "$"))
                      : props.youtubeVideo(props.el);
                  }}
                >Play</button>
              )}

              {props.type === 'VDOCipher' && (
                <button className="view-button1" onClick={() => props.vdocipherApicalling(props.el)}>Play</button>
              )}

              {props.type === 'Vimeo' && (
                <>
                  <button
                    className="view-button1"
                    onClick={() => {
                      props.vimeo(props.el);
                      props.UpdatVimeoWatchCall(props.el);
                    }}
                  >Play</button>
                  {props.vimeo_video_downlodable === true && (
                    <button className="download-button1" onClick={() => props.downloadvimeo(props.el)}>Download</button>
                  )}
                </>
              )}

              {props.type === 'AudioNotes' && (
                <button className="view-button1" onClick={() => props.listen(props.el)}>Listen</button>
              )}

              {props.type === 'Images' && (
                <button className="view-button1" onClick={() => props.image(props.el)}>View</button>
              )}
            </div>
          )}

          {isLocked && (
            <div className="locked-overlay">
              <span className="locked-text">🔒 Locked</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default StudymDoc;